module.exports = "data:image/gif;base64,R0lGODlhFAAYANUAAP//////AP/88P/54P/20P/zwP/vsP/soP/pkP/mgP/icP/iAP/fYP/cUP/ZQP/VMP/SIP/SAP/PEP/PAP/MAP/FAP+/AP+yAP+oAP+lAP+iAP+ZAP+PAP+MAP9/AP9yAP9pAP9mAP9fAP9ZAP9MAP8/AP88AP8zAP8vAP8sAP8mAP8fAP8ZAP8PAP8MAP8AAAAAAMDAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAADEALAAAAAAUABgAAAa0wJhwSCwaj7HJA3lkVCYkzPPATFY2r2yWNFEeER6tWFs5TrSi7iTTynqWxAop+8lOSq+VyA5PajNaZ1krcy8TVH55YndjhogMJy8ZG5SVlmETQwchjWudRBcvIaMToyEXGaN4ZUNnF2qwai8nma0rLSulpiERK4AXRqEeExcrbhwVdkYTbSoYbS8kWC8cDGaNWi21RhKA2NtHFWFjEw5VSd4v2ubnSRMqw+DnatbtRIj2+TFBADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ba.gif
// module id = fkoI
// module chunks = 1